import { types, actions } from './requests'
export const GETLOT_TYPES = {
    ...types('GETLOT'),
}
export const GETLOT_ACTIONS = {
    ...actions('GETLOT'),
}